








































import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class AppButtonAddCancelFailureTracking extends Vue {
  onSave() {
    this.$store.commit("SAVE_FAILURE_TRACKING_CLICK");
  }

  onCancel() {
    return this.$router.push({ name: "failure-tracking" });
  }
}
